import React from 'react';
import PropTypes from "prop-types";
import { Box, Typography, Modal } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: "3px",
};

const BasicModal = (props) => {

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="basic-modal"
        className="basic-modal"
      >
        <Box className={`basic-modal-box ${props.className}`} sx={style}>
          <Typography sx={{ mt: 2 }}>
            {props.description}
          </Typography>
          {props.children}
        </Box>
      </Modal>
    </div>
  );
};

BasicModal.propTypes = {
  children: PropTypes.any.isRequired,
  handleOpen: PropTypes.func,
  handleClose: PropTypes.func,
  open: PropTypes.any,
  className: PropTypes.string,
  description: PropTypes.object,
};

export default BasicModal;